import jwtDecode from 'jwt-decode';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import moment from 'moment';
import { FC, ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { authActions } from 'store/auth';

interface AuthGuardProps {
    page: ReactElement;
}

const AuthGuard: FC<AuthGuardProps> = (props) => {
    const location = useLocation();

    const { token } = useAuthSelector();
    const dispatch = useDispatch();

    if (!token) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    const payload: any = jwtDecode(token);

    const isExpired = moment().isAfter(moment.unix(payload.exp));

    if (isExpired) {
        dispatch(authActions.logout());

        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return props.page;
};

export default AuthGuard;
